import React, { Component } from 'react'
import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Typography from '@mui/material/Typography'
import Card from '@mui/material/Card'
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown'
import _ from 'lodash'

import { recuperarOpcoesAuditor } from '../../../actions/itensActions'
import ItensExpansionPanel from '../../util/ItensExpansionPanel'
import ItemContextMenu from '../../util/ItemContextMenu'
import { visualizarUrlSistemaLinksPrincipais, sistemas } from '../../../controllers/itensController'
import styles from './VisaoPorAuditor.module.css'
import classNames from 'classnames'
import { grey } from '@mui/material/colors'

const numItensVisiveisDocsPendentesJuntada = 3

export class VisaoPorAuditorDocsPendentesJuntada extends Component {
  constructor(props) {
    super(props)
    this.state = {
      expandedDocsPendenteJuntada: false,
      itemDocsPendentesJuntadaGridContextMenuAnchorEl: null,
      processoComDocsPendentesJuntada: null
    }
  }

  handleDocsPendenteJuntadaExpansionPanelChange(expanded) {
    this.setState({ expandedDocsPendenteJuntada: expanded })
  }

  handleDocsPendentesJuntadaGridClick(
    event,
    { codigo, codigoUnidadeResponsavelAgir, numeroCompleto, descricao },
    target = '_blank'
  ) {
    if (event) event.stopPropagation()
    const {
      unidadesUsuario: { codigoUsuario },
      itens: {
        visao: {
          informacoesAuditor: { codigoUnidadeIntegracao }
        }
      }
    } = this.props
    const indicador = JSON.stringify({
      identificador: `codigoResponsavel_${codigoUsuario}_codigoProcessoSugerido_${codigo}`,
      descricao: `${numeroCompleto} - ${descricao}`
    })
    const callback = (url) =>
      window.open(
        `${url}?redirectTo=/documentos/detalhar&visao=visaoPorAuditorAgrupador&codigoUnidadeAtual=${codigoUnidadeIntegracao}&indicador=${indicador}`,
        target
      )
    visualizarUrlSistemaLinksPrincipais(sistemas.documentos.id, callback)
  }

  handleDocsPendentesJuntadaGridItemContextMenuOpen(event, processoComDocsPendentesJuntada) {
    event.preventDefault()
    this.setState({
      itemDocsPendentesJuntadaGridContextMenuAnchorEl: event.currentTarget,
      processoComDocsPendentesJuntada
    })
  }

  handleDocsPendentesJuntadaGridItemContextMenuClose() {
    this.setState({
      itemDocsPendentesJuntadaGridContextMenuAnchorEl: null,
      processoComDocsPendentesJuntada: null
    })
  }

  handleDocsPendentesJuntadaGridItemContextMenuItemClick(target) {
    const { processoComDocsPendentesJuntada } = this.state
    this.handleDocsPendentesJuntadaGridClick(null, processoComDocsPendentesJuntada, target)
    this.handleDocsPendentesJuntadaGridItemContextMenuClose()
  }

  renderDocsPendentesJuntadaGrid() {
    const {
      itens: {
        visao: { processosDocumentosPendentesJuntada }
      }
    } = this.props
    return _.map(processosDocumentosPendentesJuntada, (processo) => (
      <Box
        my={1}
        display='flex'
        width={1}
        key={processo.codigo}
        style={{ backgroundColor: grey[200], borderRadius: '4px', marginBottom: 0 }}
        onClick={(event) => this.handleDocsPendentesJuntadaGridClick(event, processo)}
        onContextMenu={(event) =>
          this.handleDocsPendentesJuntadaGridItemContextMenuOpen(event, processo)
        }>
        <Box px={1} width='calc(100% - 68px)'>
          <Typography
            variant='subtitle2'
            noWrap
            style={{ paddingTop: '4px', maxWidth: '300px', fontWeight: 400 }}>
            {processo.numeroCompleto}
          </Typography>
          <Tooltip
            title={processo.descricao}
            aria-label={processo.descricao}
            placement='bottom-start'>
            <Typography
              variant='body2'
              color='textSecondary'
              style={{ fontSize: '0.75rem' }}
              noWrap>
              {processo.descricao}
            </Typography>
          </Tooltip>
        </Box>
        <Box className={classNames(styles.totalBox, styles.totalDocPendentes)}>
          <Typography
            variant='body2'
            color='white'
            style={{ textAlign: 'center', fontWeight: '100', fontSize: '1.45rem' }}>
            {processo.total}
          </Typography>
        </Box>
      </Box>
    ))
  }

  renderDocsPendentesJuntadaItensExpansionPanel() {
    const { itemDocsPendentesJuntadaGridContextMenuAnchorEl } = this.state
    return (
      <React.Fragment>
        <ItensExpansionPanel
          sx={{ border: 'none' }}
          numItensVisiveis={numItensVisiveisDocsPendentesJuntada}
          noBadge
          noExpandIcon
          expanded={this.state.expandedDocsPendenteJuntada}
          itensComponents={this.renderDocsPendentesJuntadaGrid()}
          expansionPanelSummaryClasses={{ content: styles.content }}
          noSummaryClickable
          onChange={(event, expanded) =>
            this.handleDocsPendenteJuntadaExpansionPanelChange(expanded)
          }
        />
        <ItemContextMenu
          itemContextMenuAnchorEl={itemDocsPendentesJuntadaGridContextMenuAnchorEl}
          handleItemContextMenuClose={this.handleDocsPendentesJuntadaGridItemContextMenuClose.bind(
            this
          )}
          handleItemContextMenuItemClick={this.handleDocsPendentesJuntadaGridItemContextMenuItemClick.bind(
            this
          )}
        />
      </React.Fragment>
    )
  }

  renderVerDocsPendentesJuntadaGrid() {
    const {
      itens: {
        visao: { processosDocumentosPendentesJuntada }
      }
    } = this.props
    const { expandedDocsPendenteJuntada } = this.state
    const isVisible =
      _.size(processosDocumentosPendentesJuntada) > numItensVisiveisDocsPendentesJuntada
    const element = expandedDocsPendenteJuntada
      ? { icon: <KeyboardArrowUp />, label: 'Ver menos' }
      : { icon: <KeyboardArrowDown />, label: 'Ver mais' }
    return (
      isVisible && (
        <Box
          display='flex'
          justifyContent='flex-end'
          className={styles.verDocsGrid}
          style={{ paddingTop: '10px' }}
          onClick={() =>
            this.handleDocsPendenteJuntadaExpansionPanelChange(!expandedDocsPendenteJuntada)
          }>
          {element.icon}
          <Typography
            variant='subtitle2'
            color='#43a047'
            style={{ textTransform: 'uppercase', margin: '2px 5px' }}>
            {element.label}
          </Typography>
        </Box>
      )
    )
  }

  render() {
    const {
      itens: {
        visao: { processosDocumentosPendentesJuntada }
      }
    } = this.props
    return (
      <Card elevation={1} style={{ borderRadius: '18px', position: 'relative', marginTop: '16px' }}>
        <Box p={2}>
          <Box display='flex' alignContent='center'>
            <Box display='flex' alignItems='center' width='calc(100% - 68px)'>
              <Typography
                variant='h6'
                style={{
                  fontWeight: '100',
                  fontSize: '20px',
                  lineHeight: '1.1em',
                  paddingLeft: '5px'
                }}>
                Documentos pendentes de juntada
              </Typography>
            </Box>
            <Box
              style={{ cursor: 'text' }}
              className={classNames(styles.totalBox, styles.totalDocPendentes)}>
              <Typography
                variant='body2'
                color='white'
                style={{ textAlign: 'center', fontWeight: '100', fontSize: '1.45rem' }}>
                {_.sumBy(processosDocumentosPendentesJuntada, 'total')}
              </Typography>
            </Box>
          </Box>
          <Box my={1}>
            {this.renderDocsPendentesJuntadaItensExpansionPanel()}
            {this.renderVerDocsPendentesJuntadaGrid()}
          </Box>
        </Box>
      </Card>
    )
  }
}

const mapStateToProps = ({ itens, unidadesUsuario }) => ({ itens, unidadesUsuario })

const reduxEnhanced = connect(mapStateToProps, { recuperarOpcoesAuditor })(
  VisaoPorAuditorDocsPendentesJuntada
)

export default withRouter(reduxEnhanced)
